// O QUE CADA TELA FAZ.
//
// Mesmo padrao do 38 Brasil: um "?" no cabecalho abre um guia rapido da tela em
// que voce esta, com topicos curtos. Nao e manual -- e o que a pessoa precisa
// saber para usar AQUELA tela sem sair dela.

export const HELP = {
  liga: {
    title: "Escolha da liga",
    lead: "Duas ligas, dois jogos diferentes -- o formato, o dinheiro e o tamanho do elenco mudam.",
    topics: [
      ["NBB", "16 times, 30 rodadas, quartos de 10 minutos e playoffs em melhor de 5. Gratis."],
      ["NBA", "30 times, 82 rodadas, quartos de 12 minutos e playoffs em melhor de 7. Faz parte do 82 Mundo."],
      ["O dinheiro muda junto", "No NBB o teto salarial e o caixa sao muito menores. Uma contratacao pesa bem mais no orcamento."],
      ["Da para trocar depois?", "A carreira nasce numa liga e fica nela. Para jogar a outra, comece outra carreira."],
    ],
  },
  clube: {
    title: "Escolha do clube",
    lead: "O clube define a sua dificuldade -- e a diretoria cobra pelo elenco que voce tem, nao pelo escudo.",
    topics: [
      ["Candidatos ao titulo", "Elenco pronto e cobranca alta. Nao ser campeao ja e fracasso."],
      ["Briga por playoffs", "O meio da tabela: da para subir com bons movimentos no mercado."],
      ["Desafio", "Elenco fraco e caixa curto. A meta e baixa, entao ha espaco para reconstruir."],
      ["Elencos reais", "Cada clube comeca com o grupo que tem de verdade. O que acontece dali em diante depende de voce."],
      ["Seu nome", "E como a diretoria e as noticias vao te chamar durante a carreira."],
    ],
  },
  painel: {
    title: 'Painel',
    lead: 'O centro da temporada: proximo jogo, situacao com a diretoria e o que aconteceu no mercado.',
    topics: [
      ['▶ Jogar', 'Abre a partida ao vivo, com cronometro e narracao. Da para pausar e substituir no meio do jogo.'],
      ['Simular', 'O resultado sai na hora, sem assistir. Mesmo motor, mesmo jogo.'],
      ['+5 / +20 rodadas', 'Avanca varias rodadas de uma vez. Util para atravessar a temporada rapido.'],
      ['Meta da diretoria', 'Quanto se espera do SEU elenco -- nao do escudo. Ficar muito abaixo dela custa o emprego.'],
      ['Reputacao', 'Sobe com titulo, cai com demissao. E ela que decide quais clubes te procuram depois.'],
    ],
  },
  elenco: {
    title: 'Elenco',
    lead: 'Todos os seus atletas, com o que eles sao hoje e o que podem virar.',
    topics: [
      ['Overall e potencial', 'O primeiro e o que ele e agora; o segundo e o teto. Jovem com potencial alto vale investimento.'],
      ['Tocar num atleta', 'Abre a ficha com estatisticas da temporada e atributos.'],
      ['Lista de transferencias', 'Poe o atleta a venda e atrai propostas. Ninguem faz proposta pelo ultimo do banco.'],
      ['Dispensar', 'Rescinde o contrato. Custa dinheiro e nao devolve nada.'],
      ['Teto e piso', 'O elenco tem tamanho minimo e maximo. Comprar com o elenco cheio exige vender antes.'],
    ],
  },
  escalacao: {
    title: 'Escalacao e sistema de jogo',
    lead: 'Quem comeca, quantos minutos cada um joga, e como o time joga.',
    topics: [
      ['Quinteto inicial', 'Os 5 que comecam a partida. Escolha exatamente 5.'],
      ['Minutos', 'Uma proporcao, nao uma trava: o motor normaliza para os 240 minutos do jogo e faz a rotacao seguindo ela.'],
      ['Automatica', 'Devolve a rotacao para o motor, baseada na qualidade de cada um.'],
      ['Sistema de jogo', 'Ritmo, ataque, quem decide e defesa. Toda escolha tem um custo -- nenhuma e so vantagem.'],
      ['Depende do elenco', 'Forcar o jogo por dentro num time de arremessadores piora o time. O aproveitamento sai dos atributos de cada atleta.'],
    ],
  },
  mercado: {
    title: 'Mercado',
    lead: 'Comprar, vender e responder as propostas que chegam.',
    topics: [
      ['Preco pedido', 'E o valor de mercado mais uma margem -- e o INTERESSE do atleta mexe nesse preco.'],
      ['Salario muda o preco', 'Ofereca mais salario e veja o preco pedido cair na mesma tela. Clube grande atrai, banco espanta.'],
      ['Contraproposta', 'Proposta perto do pedido volta com um numero. Pedir demais faz o comprador desistir.'],
      ['Propostas recebidas', 'Aceitar, recusar ou contrapor. A etiqueta diz se a oferta esta acima ou abaixo do valor.'],
      ['Data limite', 'O mercado fecha na data limite de trocas e so reabre na entressafra. Nao ha negociacao nos playoffs.'],
    ],
  },
  tabela: {
    title: 'Classificacao e lideres',
    lead: 'Onde voce esta na liga e quem esta se destacando.',
    topics: [
      ['O corte dos playoffs', 'O ponto marcado na tabela mostra quem entra. Os primeiros de cada conferencia avancam.'],
      ['Saldo', 'Diferenca de pontos por jogo. Diz mais sobre o time do que a campanha isolada.'],
      ['Lideres', 'Pontos, cestas de 3, cestas de 2, rebotes, assistencias, roubos e tocos.'],
      ['Playoffs', 'Quando eles comecam, esta aba mostra o chaveamento em vez da tabela.'],
    ],
  },
  jogos: {
    title: 'Jogos',
    lead: 'As sumulas completas das suas ultimas partidas.',
    topics: [
      ['Sumula', 'Minutos, pontos, aproveitamento, rebotes, assistencias, erros e saldo de cada atleta.'],
      ['TS%', 'Aproveitamento verdadeiro: conta arremessos de 2, de 3 e lances livres juntos. E a medida honesta de quem arremessa bem.'],
      ['Quartos', 'O placar parcial de cada periodo, para ver onde o jogo virou.'],
      ['Ultimas jogadas', 'O fim da partida, jogada a jogada.'],
    ],
  },
  galeria: {
    title: 'Trofeus e historico',
    lead: 'O que voce ja conquistou, e o que ainda falta.',
    topics: [
      ['Sala de trofeus', 'Os que voce ainda nao ganhou aparecem apagados: a galeria mostra o que falta, nao so o que ja tem.'],
      ['Premios individuais', 'MVP, cestinha, rei do 3, rei do garrafao, melhor defensor, novato e sexto homem, temporada a temporada.'],
      ['Historico', 'Cada temporada com sua campanha, o titulo daquele ano, o campeao da liga e o seu cestinha.'],
      ['MVP', 'Nao e o cestinha: producao com vitoria pesa mais que producao em time ruim, como na vida real.'],
    ],
  },
  draft: {
    title: 'Draft',
    lead: 'A noite em que os calouros escolhem dono -- ou o contrario.',
    topics: [
      ['Loteria', 'Na NBA, os times fora dos playoffs sorteiam as quatro primeiras escolhas. As tres piores campanhas tem 14% cada.'],
      ['Ordem', 'Da quinta escolha em diante e a ordem inversa da classificacao. O campeao escolhe por ultimo.'],
      ['Teto estimado', 'E o que o OLHEIRO acha, uma faixa -- nunca o numero real. Ele erra, e e por isso que escolher e decisao.'],
      ['Calouro e cru', 'O melhor da classe entra abaixo dos titulares da liga. O que ele traz e potencial, nao presente.'],
    ],
  },
};

// ---------------------------------------------------------------------------
// QUAIS TELAS A PESSOA JÁ VIU
//
// A ajuda abre sozinha na PRIMEIRA vez que alguém chega numa tela, e nunca
// mais. Explicar de novo a quem já entendeu é o caminho mais rápido para a
// pessoa fechar tudo sem ler — inclusive na tela em que precisaria.
//
// Fica no aparelho, e não no save: quem começa outra carreira não quer o
// tutorial de novo. Se o armazenamento estiver bloqueado, a ajuda simplesmente
// não abre sozinha — nada quebra por causa disso.

const VISTAS_KEY = 'basquete82.telasVistas';

function lerVistas() {
  try {
    const cru = localStorage.getItem(VISTAS_KEY);
    return cru ? new Set(JSON.parse(cru)) : new Set();
  } catch { return new Set(); }
}

/** Já viu esta tela alguma vez? */
export function telaJaVista(id) {
  return lerVistas().has(id);
}

/** Marca a tela como vista. Devolve true se era a primeira vez. */
export function marcarTelaVista(id) {
  const vistas = lerVistas();
  if (vistas.has(id)) return false;
  vistas.add(id);
  try { localStorage.setItem(VISTAS_KEY, JSON.stringify([...vistas])); } catch { /* bloqueado */ }
  return true;
}

/** Para o painel do usuário: começar o tutorial de novo. */
export function esquecerTelasVistas() {
  try { localStorage.removeItem(VISTAS_KEY); } catch { /* bloqueado */ }
}
